import { createSelector } from 'reselect';

const getConfirm = (state) => state.sceneConfiguration.confirm;

const getConfirmState = createSelector([getConfirm], (confirm) => confirm);

export default getConfirmState;
